module.exports = __webpack_public_path__ + "static/media/menu.0e4275dd.png";